import { z } from "zod";

export const MediaSourceSchema = z.object({
  /** original part in deck.media */
  mediaId: z.string(),
  playable: z.enum(["native", "afterTranscode", "no"]),
  container: z.enum(["mp4", "m4a", "mp3", "wav", "webm", "mov", "wmv", "wma", "avi", "other"]),
  codecs: z.object({ video: z.string().optional(), audio: z.string().optional() }).default({}),
  /** ms, when readable from the container */
  duration: z.number().nullable().default(null),
});
export type MediaSource = z.infer<typeof MediaSourceSchema>;

export const MediaRefSchema = z.object({
  /** sha256 prefix of the bytes */
  id: z.string(),
  /** R2 object key */
  key: z.string(),
  mime: z.string(),
  bytes: z.number(),
  kind: z.enum(["image", "video", "audio"]),
  w: z.number().optional(),
  h: z.number().optional(),
  transcode: z
    .object({
      status: z.enum(["none", "queued", "running", "ready", "failed", "skipped"]),
      key: z.string().optional(),
      mime: z.string().optional(),
      reason: z.string().optional(),
    })
    .optional(),
});
export type MediaRef = z.infer<typeof MediaRefSchema>;

export const StartModeSchema = z.enum(["auto", "inClickSequence", "onClickShape", "manual"]);
export type StartMode = z.infer<typeof StartModeSchema>;
